module.exports = __webpack_public_path__ + "img/klarna.9d47a2f.svg";